import { ActionReducer } from '@ngrx/store';
import { loadingStatusAdd, loadingStatusRemove, StatusAction } from '../../../core/reducers/loading-status.reducer';
import * as consentActions from '../actions/consent.actions';
import * as enableActions from '../actions/enable-consent.actions';
import * as disableActions from '../actions/disable-consent.actions';

type Actions = consentActions.Actions | enableActions.Actions | disableActions.Actions;

/**
 * Loading status reducer for consent - adds or removes loading flag from store.
 */
export const loadingStatus: ActionReducer<any> = (state: string[] = [], {type}: Actions) => {
    switch (type) {
        case consentActions.LOAD_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, consentActions.LOAD_REQUEST));
        case consentActions.LOAD_SUCCESS:
        case consentActions.LOAD_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, consentActions.LOAD_REQUEST));

        // first initial update request; authorization iframe follows
        case enableActions.ENABLE_CONSENT_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, enableActions.ENABLE_CONSENT_REQUEST));
        case enableActions.ENABLE_CONSENT_SUCCESS:
        case enableActions.ENABLE_CONSENT_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, enableActions.ENABLE_CONSENT_REQUEST));

        // get status - finish of authorization
        case enableActions.ENABLE_CONSENT_STATUS_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, enableActions.ENABLE_CONSENT_STATUS_REQUEST));
        case enableActions.ENABLE_CONSENT_STATUS_SUCCESS:
        case enableActions.ENABLE_CONSENT_STATUS_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, enableActions.ENABLE_CONSENT_STATUS_REQUEST));


        // disable requests - no authorization
        case disableActions.DISABLE_CONSENT_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, disableActions.DISABLE_CONSENT_REQUEST));
        case disableActions.DISABLE_CONSENT_SUCCESS:
        case disableActions.DISABLE_CONSENT_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, disableActions.DISABLE_CONSENT_REQUEST));

        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/reducers/loading-status.reducer.ts